import { render, staticRenderFns } from "./loglook.vue?vue&type=template&id=2d5f145d&scoped=true&"
import script from "./loglook.vue?vue&type=script&lang=js&"
export * from "./loglook.vue?vue&type=script&lang=js&"
import style0 from "./loglook.vue?vue&type=style&index=0&id=2d5f145d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f145d",
  null
  
)

export default component.exports